import type { ApplicationSettingAuthentication, FieldType } from '@lighthouse/core'
import { ApplicationSettingPerfectMode, SMS_TYPE } from '@lighthouse/core'

export const registerModeList: {
    label: string
    value: ApplicationSettingPerfectMode
}[] = [
    {
        label: '自定义',
        value: ApplicationSettingPerfectMode.COMMON
    },
    {
        label: '按角色定义',
        value: ApplicationSettingPerfectMode.ROLE
    }
]

export const selectTypeList: FieldType[] = ['text', 'email', 'phoneNumber', 'url', 'number', 'select', 'date', 'checkbox']

export const selectUserSystemFieldIds = ['USERNAME', 'DEPARTMENT', 'ROLE']
